import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { reduxForm, initialize, destroy } from 'redux-form'
import { CharField, FieldError } from 'components/forms'
import { Button } from 'components/util'
import * as auth from 'services/auth/selectors'
import messages from '../messages'
import styles from './_login.css'

export const FORM_NAME = 'login'

const validate = (values) => {
  const errors = {}
  if (!values.email) { errors.email = 'required' }
  if (!values.password) { errors.password = 'required' }
  return errors
}

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = (state) => ({
  onboardingEmail: auth.selectOnboardingEmail(state),
})

const mapDispatchToActions = {
  initialize,
  destroy,
}

export class LoginForm extends Component {

  static propTypes = {
    initialize: PropTypes.func,
    intl: PropTypes.object,
    loggingIn: PropTypes.bool,
    onClickSignup: PropTypes.func,
    onClickForgotPassword: PropTypes.func,
    onLoginSuccess: PropTypes.func,
    handleSubmit: PropTypes.func,
    error: PropTypes.object,
    onboardingEmail: PropTypes.string,
  }

  componentWillMount () {
    const { onboardingEmail } = this.props
    if (onboardingEmail && onboardingEmail.length) {
      this.props.initialize({ email: onboardingEmail })
    }
  }

  render () {
    const { handleSubmit, loggingIn, error, intl } = this.props

    return (
      <form method='post' onSubmit={handleSubmit}>

        {error ?
          <FieldError
            showError={true}
            errorComponent={(
              <FormattedMessage
                id='auth.login.error.incorrect_credentials'
                defaultMessage='Incorrect username or password. Please try again.'
              />
            )}
          />
        : null}

        <CharField
          slim
          name='email'
          placeholder={intl.formatMessage(messages.email)}
          labelComponent={null}
          errorComponent={(
            <FormattedMessage
              id='auth.login.error.email'
              defaultMessage='Email is required.'
            />
          )}
          disabled={loggingIn}
          normalize={(value) => value.trim()}
        />

        <CharField
          slim
          name='password'
          type='password'
          placeholder={intl.formatMessage(messages.password)}
          labelComponent={null}
          errorComponent={(
            <FormattedMessage
              id='auth.login.error.password'
              defaultMessage='Password is required.'
            />
          )}
          disabled={loggingIn}
          normalize={(value) => value.trim()}
        />

        <a
          href='/auth/forgot_password'
          className={styles.forgot}
          onClick={this.props.onClickForgotPassword}
        >
          <FormattedMessage
            id='auth.login.forgot_password'
            defaultMessage='Forgot Password?'
          />
        </a>

        <Button
          el='button'
          type='success'
          disabled={loggingIn}
          className={styles.button}
        >
          <FormattedMessage
            id='auth.login.log_in'
            defaultMessage='Log In'
          />
        </Button>

      </form>
    )
  }

}

export const Form = reduxForm(formOptions)(LoginForm)
export const IntlForm = injectIntl(Form)

export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: true })(IntlForm)

